import ReactNative from '../base_components';
import React from 'react';

import { Game } from '../../data/games';

const { StyleSheet, View, Image, Text, TouchableHighlight } = ReactNative;

const styles = StyleSheet.create({
  gameButton: {
    width: '10em',
    height: '13em',
    flexDirection: 'row',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
    borderRadius: '0.3em',
    backgroundColor: 'rgba(0,0,0,0.2)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '8em',
    height: '8em',
    borderRadius: '0.2em',
  },
  text: {
    marginLeft: '1em',
    marginRight: '1em',
    marginTop: '1em',
    color: 'white',
    fontSize: '1em',
    textAlign: 'center',
  },
});

type Props = {
  style: any;
  game: Game;
  onPress: (Game) => null;
};

export default class GameButton extends React.PureComponent<Props> {
  _onPress = () => {
    this.props.onPress(this.props.game);
  };
  render() {
    const { style, game } = this.props;
    const { display_name, image_url } = game;

    return (
      <View style={[styles.gameButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor='rgba(255,255,255,0.2)'
          onPress={this._onPress}
        >
          <Image style={styles.icon} source={image_url} />
          <Text style={styles.text}>{display_name}</Text>
        </TouchableHighlight>
      </View>
    );
  }
}
